import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    UndeleteLandingPage as UndeleteLandingPageMutation,
    UndeleteLandingPageVariables as UndeleteLandingPageMutationVariables,
} from 'nutshell-graphql-types';

import UNDELETE_LANDING_PAGE from '../mutations/undelete-landing-page.graphql';
import GET_LANDING_PAGES from '../queries/get-landing-pages.graphql';

export function useUndeleteLandingPage(archived: boolean): {
    undeleteLandingPage: (id: string) => Promise<any>;
    isDeleting: boolean;
    error: string | null | undefined;
} {
    const [undeleteLandingPage, {loading: isDeleting, error}] = useMutation<
        UndeleteLandingPageMutation,
        UndeleteLandingPageMutationVariables
    >(UNDELETE_LANDING_PAGE);

    // @ts-expect-error
    const errorMessage = safelyGetGraphQLErrorMessage(error);

    return {
        undeleteLandingPage: (id: string) =>
            undeleteLandingPage({
                variables: {input: {id}},
                update: (proxy, mutationResults) => {
                    const undeletedPage =
                        mutationResults &&
                        mutationResults.data &&
                        mutationResults.data.pageUndelete &&
                        mutationResults.data.pageUndelete.page;

                    const cacheResult = proxy.readQuery({
                        query: GET_LANDING_PAGES,
                        variables: {
                            archived,
                        },
                    });

                    if (cacheResult && undeletedPage) {
                        proxy.writeQuery({
                            query: GET_LANDING_PAGES,
                            variables: {archived},
                            data: {
                                // @ts-expect-error
                                pages: cacheResult.pages.filter(
                                    // @ts-expect-error
                                    (page) => page.id !== undeletedPage.id
                                ),
                            },
                        });
                    }
                },
            }),
        isDeleting,
        error: errorMessage,
    };
}
